var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M19.9482 5.41309H17.9482V7.41309H19.9482V5.41309ZM19.9482 11.4131H17.9482V13.4131H19.9482V11.4131ZM9.94824 6.41309C9.55268 6.41309 9.166 6.53038 8.8371 6.75015C8.5082 6.96991 8.25186 7.28227 8.10048 7.64772C7.94911 8.01317 7.9095 8.4153 7.98667 8.80327C8.06384 9.19123 8.25432 9.54759 8.53403 9.8273C8.81373 10.107 9.1701 10.2975 9.55806 10.3747C9.94602 10.4518 10.3482 10.4122 10.7136 10.2608C11.0791 10.1095 11.3914 9.85312 11.6112 9.52423C11.8309 9.19533 11.9482 8.80865 11.9482 8.41309C11.9482 7.88265 11.7375 7.37395 11.3625 6.99887C10.9874 6.6238 10.4787 6.41309 9.94824 6.41309ZM12.9482 13.4131C12.9482 12.6174 12.6322 11.8544 12.0696 11.2918C11.507 10.7292 10.7439 10.4131 9.94824 10.4131C9.15259 10.4131 8.38953 10.7292 7.82692 11.2918C7.26431 11.8544 6.94824 12.6174 6.94824 13.4131V14.4131H12.9482V13.4131Z",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M16.9482 1.41357H2.94824C2.39596 1.41357 1.94824 1.86129 1.94824 2.41357V18.4136C1.94824 18.9659 2.39596 19.4136 2.94824 19.4136H16.9482C17.5005 19.4136 17.9482 18.9659 17.9482 18.4136V2.41357C17.9482 1.86129 17.5005 1.41357 16.9482 1.41357Z",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalContact);
export default __webpack_public_path__ + "static/media/externalContact.82d21e6f19231619500d1e8759fa15f3.svg";
export { ForwardRef as ReactComponent };